// extracted by mini-css-extract-plugin
module.exports = {"container":"e_FD","title":"e_GD","wavy":"e_HD","navLink":"e_ID","active":"e_JD","iconArrow":"e_KD"};